// extracted by mini-css-extract-plugin
module.exports = {"headline":"home2_headline__WijBl","headlineP":"home2_headlineP__kkkQI","bodyHolder":"home2_bodyHolder__2s1CN","hello":"home2_hello__2Q1pF","logout":"home2_logout__2o7Tk"};